<template>
  <div>
    <div
      class="main-modal main-modal_w796 main-modal_h85vh"
      :class="{
        'empoyee-form_reviews': layout === 'reviews',
      }"
    >
      <div class="main-form__header">
        <div class="main-modal__title main-modal__title_flex">
          <p v-if="typeAction === 'add'">{{ $t("masters.add") }}</p>
          <p v-else>{{ $t("masters.update") }}</p>

          <div class="main-form__actions" v-if="typeAction !== 'add'">
            <router-link
              class="empoyee-form__link"
              tag="span"
              :to="{
                name: 'master-calendar',
                params: { employee_id: dataUser.id },
                query: { master: dataUser.id },
              }"
            >
              <svg class="icon" width="35px" height="35px">
                <use xlink:href="/images/svg/symbols.svg#svg-user-calendar" />
              </svg>
            </router-link>

            <svg
              v-if="$guard('read', 'Chat')"
              @click="openChat(dataUser.id)"
              width="35px"
              height="35px"
              id="open-chat"
              viewBox="-21 -47 682.66669 682"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="var(--bg-color-green)"
                d="m552.011719-1.332031h-464.023438c-48.515625 0-87.988281 39.464843-87.988281 87.988281v283.972656c0 48.414063 39.300781 87.816406 87.675781 87.988282v128.863281l185.191407-128.863281h279.144531c48.515625 0 87.988281-39.472657 87.988281-87.988282v-283.972656c0-48.523438-39.472656-87.988281-87.988281-87.988281zm50.488281 371.960937c0 27.835938-22.648438 50.488282-50.488281 50.488282h-290.910157l-135.925781 94.585937v-94.585937h-37.1875c-27.839843 0-50.488281-22.652344-50.488281-50.488282v-283.972656c0-27.84375 22.648438-50.488281 50.488281-50.488281h464.023438c27.839843 0 50.488281 22.644531 50.488281 50.488281zm0 0"
              />
              <path
                fill="var(--bg-color-green)"
                d="m171.292969 131.171875h297.414062v37.5h-297.414062zm0 0"
              />
              <path
                fill="var(--bg-color-green)"
                d="m171.292969 211.171875h297.414062v37.5h-297.414062zm0 0"
              />
              <path
                fill="var(--bg-color-green)"
                d="m171.292969 291.171875h297.414062v37.5h-297.414062zm0 0"
              />
            </svg>

            <svg
              @click="openMasterSchedule(dataUser.id)"
              width="35px"
              height="35px"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.9499 18.9999H2.05C1.45 18.9999 1 18.5499 1 17.9499V2.05C1 1.45 1.45 1 2.05 1H17.8749C18.4749 1 18.9249 1.45 18.9249 2.05V17.8749C18.9999 18.5499 18.5499 18.9999 17.9499 18.9999Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.99997 6.99997H1V2.05C1 1.45 1.45 1 2.05 1H6.99997V6.99997Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.9999 1H6.99994V6.99997H12.9999V1Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19 6.99997H13V1H17.95C18.55 1 19 1.45 19 2.05V6.99997Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.99997 6.99976H1V12.9997H6.99997V6.99976Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.9999 6.99976H6.99994V12.9997H12.9999V6.99976Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19 6.99976H13V12.9997H19V6.99976Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.99997 19H2.05C1.45 19 1 18.55 1 17.95V13H6.99997V19Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.9999 13H6.99994V19H12.9999V13Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.95 19H13V13H19V17.95C19 18.55 18.55 19 17.95 19Z"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.79999 8.80005L11.2 11.2"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.2 8.80005L8.79999 11.2"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.79999 14.7998L5.19998 17.1998"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.19998 14.7998L2.79999 17.1998"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.7999 8.80005L17.1999 11.2"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.1999 8.80005L14.7999 11.2"
                stroke="#9BCD82"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="main-form__tabs">
        <specialist-tab
          :layout="layout"
          :text="$t('masters.data')"
          :type="'default'"
          @changeLayout="changeLayout"
        />

        <!-- <specialist-tab
          :layout="layout"
          :text="'Schedule'"
          :type="'schedule'"
          @changeLayout="changeLayout"
          v-if="isEdit"
        />-->

        <specialist-tab
          v-if="isEdit"
          :layout="layout"
          :text="'Aufträge'"
          :type="'reviews'"
          @changeLayout="changeLayout"
        />

        <specialist-tab
          v-if="isEdit"
          :layout="layout"
          :text="'Abzeichen'"
          :type="'badges'"
          @changeLayout="changeLayout"
        />

        <specialist-tab
          v-if="isEdit"
          :layout="layout"
          :text="'Dateien'"
          :type="'files'"
          @changeLayout="changeLayout"
        />

        <specialist-tab
          v-if="isEdit"
          :layout="layout"
          :text="$t('controls.skills')"
          :type="'tags'"
          @changeLayout="changeLayout"
        />
      </div>

      <template>
        <component
          :is="layout"
          :specialistComments="specialistComments"
          :typeAction="typeAction"
          :canCreate="canCreate"
          :dataUser="dataUser"
          :id="currentId"
          :type="type"
          :schedule="schedule"
          :services="services"
          :partners="partners"
          :badges="badges"
          @okAction="confirm"
          @updateAvatar="updateImage"
          :setAvatar="setAvatar"
          @fetchOrder="fetchOrder"
          @cancelAction="close"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import mainView from './view/mainView'
import reviewsView from './view/reviewsView'
import badgesView from './view/badgesView'
import scheduleView from './view/scheduleView'
import filesView from './view/filesView'
import tagsView from './view/tagsView'

import specialistTab from './specialistTab'

export default {
    props: [
        'typeAction',
        'typeEmployee',
        'services',
        'okAction',
        'cancelAction',
        'newDataEmployee',
        'setAvatar',
        'updateAvatar',
        'request',
        'type',
        'changeView',
    ],
    components: {
        default: mainView,
        reviews: reviewsView,
        badges: badgesView,
        schedule: scheduleView,
        files: filesView,
        tags: tagsView,

        specialistTab,
    },
    data() {
        return {
            data: [],
            layout: 'default',
            partnersOption: null,
            badges: [
                {
                    id: 1,
                    name: 'Hardworker',
                    is_active: false,
                },
                {
                    id: 2,
                    name: 'Handsome',
                    is_active: true,
                },
                {
                    id: 3,
                    name: 'Big daddy',
                    is_active: false,
                },
            ],
            role: window.$role,
        }
    },
    computed: {
        ...mapGetters({
            schedule: 'schedule/scheduleGetters',
            specialistComments: 'specialists/specialistCommentsGetters',
            partners: 'partners/partnersGetters',
            appeal: 'appealGetters',
            dataEmployee: 'specialists/getSpecialist',
            createdId: 'specialists/created_id',
        }),
        canCreate() {
            return (
                this.schedule.week_days.length !== 0
                && this.schedule.date_from !== ''
                && this.schedule.date_till !== ''
                && this.schedule.time_from !== ''
                && this.schedule.time_till !== ''
            )
        },
        dataUser() {
            if (this.typeAction === 'add') {
                return this.newDataEmployee
            } else {
                return this.dataEmployee
            }
        },
        requestState() {
            if (this.request === 'success') {
                this.$emit('cancelAction')
            }
            return this.request
        },
        isEdit() {
            return this.typeAction !== 'add'
        },
        currentId() {
            return this.createdId === null ? this.dataUser.id : this.createdId
        },
    },
    watch: {
        changeView(v) {
            if (v === true) {
                this.changeLayout('schedule')
            }
        },
    },
    methods: {
        ...mapActions({
            fetchComments: 'specialists/fetchComments',
            fetchPartners: 'partners/fetch',
        }),
        ...mapMutations({
            setState: 'sip/setState',
            clearCreatedId: 'specialists/setState',
            setStateSpecialist: 'specialists/setState',
        }),
        openMasterSchedule(data) {
            this.setStateSpecialist({
                type: 'scheduleMasterId',
                data,
            })

            this.setStateSpecialist({
                type: 'isActive',
                data: 'schedule',
            })

            this.close()
        },
        fetchOrder(id) {
            this.$emit('fetchOrder', id)
        },
        toCapitilize(v) {
            const word = v.split('')
            word[0] = word[0].toUpperCase()
            return word.join('')
        },
        close() {
            this.$emit('cancelAction')
        },
        openChat(id) {
            this.$router.push({ name: 'chat', params: { id, type: this.type } })
            this.close()
        },
        openCall(id, firstName, lastName, photo, isAudioCall) {
            const user = {
                fullName: `${firstName} ${lastName}`,
                photo,
                id,
                type: this.type,
                isAnswer: false,
                isAudioCall,
            }
            this.$store.dispatch('showCallModal', user)
            this.close()
        },
        inWeekDays(id) {
            return this.schedule.week_days.lastIndexOf(id) !== -1
        },
        changeLayout(v) {
            this.layout = v
        },
        confirm() {
            this.$emit('okAction')
        },
        updateImage(id, formData) {
            this.$emit('updateAvatar', id, formData)
        },
    },
    beforeMount() {
        if (this.dataUser.partner === null) {
            return
        }

        if (this.dataUser.partner.id === null) {
            return
        }

        this.dataUser.partner_id = this.dataUser.partner.id
    },
    async mounted() {
        await this.fetchPartners({})

        console.log(this.dataEmployee)
        if (this.typeAction !== 'add') {
            await this.fetchComments({ type: 'masters', id: this.dataEmployee.id })
        }
    },
    beforeDestroy() {
        this.clearCreatedId({
            type: 'created_id',
            data: null,
        })
    },
}
</script>

<style lang="scss" scoped>
// .form-select {
//   width: 100%;
//   height: 40px;
//   border-radius: 8px;
//   background-color: #ffffff;
//   border: 1px solid #e0e0e0;
// }

// .replace-all {
//   width: 20px;
//   height: 20px;
//   border: 1px solid #444;
//   display: block;

//   &:checked {
//     border: 1px solid red;
//   }
// }

// .master-comments {
//   border-top: 1px solid lightgrey;
//   margin-top: 20px;
//   width: 100%;
//   max-height: 74vh;
//   overflow-y: auto;

//   p {
//     color: #4d4d4d;
//     font-family: "SFUIDisplay-Regular";
//     font-size: 18px;
//   }
// }

// .master-comment {
//   display: flex;
//   padding: 6px 0;
//   width: 100%;
//   word-break: break-all;

//   &:nth-child(odd) {
//     background-color: #f8f5f5;
//   }

//   &__rate {
//     width: 10%;
//     text-align: center;
//   }

//   &__comments {
//     width: 70%;
//     box-sizing: border-box;
//     padding-left: 5%;
//   }

//   &__link {
//     width: 20%;
//   }
// }

// .tabs {
// margin-bottom: 30px;
// display: flex;

// border: 1px solid var(--border-color);

//   .tab {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     min-width: 60px;
//     // height: 20px !important;
//     background-color: var(--bg-color2);
//     font-size: 14px;
//     color: var(--menu-text-color);
//     padding: 8px 20px;
//     font-family: "lexend_deca";

//     // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//     cursor: pointer;

//     &:first-child {
//       border-radius: 4px 0 0 4px;
//     }

//     &:last-child {
//       border-radius: 0 4px 4px 0;
//     }

//     &_active {
//       background-color: var(--bg-color-green);
//       color: #000;
//       box-shadow: unset;
//     }
//   }
// }
// .empoyee {
//   &-form {
//     overflow: auto;
//     width: calc(885px - 130px);
//     height: 85vh;
//     position: relative;
//     padding: 36px;

//     &_reviews {
//       display: block;
//     }

//     &__header {
//       width: 100%;
//       display: flex;
//       font-size: 36px;
//       justify-content: space-between;
//       padding-bottom: 16px;

//       p {
//         margin: 0;
//       }
//     }

//     &__close {
//       position: absolute;
//       right: 0;
//       top: 0;

//       svg {
//         width: 40px;
//         height: 40px;
//       }
//     }

//     &__button {
//       &_update {
//         background-color: var(--bg-color-green);
//         width: 156px;
//         height: 45px;
//         text-align: center;
//         color: #fff;
//         border: none;
//         border-radius: 8px;
//         font-size: 16px;
//         cursor: pointer;
//         transition: all 0.6s;
//         &:hover {
//           background-color: #8bc36f;
//         }
//       }
//     }

//     &__actions {
//       display: flex;
//       align-items: center;
//       margin-left: 76px;

//       svg {
//         margin-left: 21px;
//         transition: transform 0.6s;
//       }
//     }

//     &__img {
//       width: 230px;
//       height: 244px;
//       display: block;
//       background-position: center;
//       background-size: cover;

//       input {
//         display: none;
//       }
//     }

//     &__info {
//       display: flex;
//     }

//     &__left {
//       min-width: 243px;
//     }

//     &__link {
//       height: 35px;
//     }

//     &__rating {
//       display: flex;
//       justify-content: center;
//       align-items: flex-end;
//       color: #4d4d4d;
//       font-size: 16px;
//       margin-bottom: 8px;

//       span {
//         font-size: 18px;
//         color: var(--bg-color-green);
//         display: inline-block;
//         margin: 0 6px;
//       }
//     }

//     &__completed {
//       text-align: center;
//       font-size: 16px;
//       color: #4d4d4d;
//       margin: 0;

//       span {
//         color: var(--bg-color-green);
//       }
//     }

//     // form info
//     &__right {
//       width: calc(100% - 30px);
//       display: flex;
//       justify-content: space-between;
//       flex-wrap: wrap;
//       padding-left: 30px;
//     }

//     &__half {
//       width: 48%;
//       margin: 10px 0;

//       input {
//         padding-left: 20px;
//         width: calc(100% - 30px);
//         color: #4d4d4d;
//         height: 45px;

//         border-radius: 8px;
//         border: 1px solid #e0e0e0;

//         color: #444;
//         font-size: 16px;
//       }
//     }

//     &__full {
//       width: 98%;
//       margin: 10px 0;

//       input {
//         padding-left: 20px;
//         color: #4d4d4d;
//         width: calc(100% - 20px);
//         height: 45px;
//         color: #444;

//         border-radius: 8px;
//         border: 1px solid #e0e0e0;
//         font-size: 16px;
//       }
//     }

//     &__service {
//       width: 100%;
//       margin-bottom: 10px;
//     }

//     &__cta {
//       width: 100%;
//       color: #fff;
//       display: flex;
//       justify-content: center;
//       margin-top: 45px;

//       button,
//       span {
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         width: 156px;
//         height: 45px;
//         color: #fff;
//         border: none;
//         border-radius: 8px;
//         font-size: 16px;
//         margin: 0 32.5px;
//       }

//       &_add,
//       &_cancel {
//         background-color: #61422d;
//         transition: all 0.5s;
//         cursor: pointer;
//         position: relative;
//         z-index: 9;

//         &:hover {
//           background-color: #fcee21;
//           color: #000000 !important;
//         }
//       }
//     }
//   }
// }
// .disableBtn {
//   background-color: rgba(97, 66, 45, 0.5);
//   z-index: 2;
//   position: relative;

//   &:hover {
//     outline: none;
//     cursor: unset;
//     background-color: rgba(97, 66, 45, 0.5);
//   }
// }
// .schedule {
//   display: flex;
//   justify-content: space-between;
//   margin-top: 10px;

//   &-period {
//     padding-right: 30px;

//     &__datepicker {
//       height: 52px;
//       padding-left: 10px;
//       border-radius: 8px;
//       border: 1px solid #e0e0e0;
//       display: flex;
//       align-items: center;
//       margin: 0 8px;
//       position: relative;

//       &_inactive {
//         &::after {
//           position: absolute;
//           right: 20px;
//           top: 30%;
//           content: "";
//           background-image: url(/images/calendar.png);
//           width: 20px;
//           height: 20px;
//           z-index: 3;
//         }
//       }
//     }

//     &__from-to {
//       display: flex;
//       align-items: center;
//       margin-bottom: 30px;

//       p {
//         font-size: 16px;
//         color: rgba(51, 49, 50, 0.5);
//       }

//       input {
//         height: 50px;
//         border-radius: 8px;
//         border: 1px solid #e0e0e0;
//         color: #444;
//         font-size: 16px;
//         width: 77px;
//         margin: 0 8px;
//         padding-left: 15px;
//       }
//     }

//     &__time {
//       display: flex;
//       align-items: center;
//       p {
//         font-size: 16px;
//         color: rgba(51, 49, 50, 0.5);
//       }

//       input {
//         height: 50px;
//         border-radius: 8px;
//         border: 1px solid #e0e0e0;
//         color: #444;
//         font-size: 16px;
//         width: 80px;
//         margin: 0 8px;
//         padding-left: 15px;
//       }
//     }
//   }

//   &-weeks {
//     &__title {
//       margin-top: 0;
//       color: #4d4d4d;
//       font-size: 18px;
//     }

//     &__btns {
//       display: flex;

//       span {
//         width: 43px;
//         padding: 17px 0;
//         font-size: 16px;
//         border: 1px solid #e0e0e0;
//         border-radius: 8px;
//         display: inline-block;
//         margin-right: 7px;
//         text-align: center;
//         cursor: pointer;
//       }
//     }
//   }

//   &-week {
//     &_active {
//       background-color: var(--bg-color-green);
//     }
//   }
// }
</style>
<style>
/* .empoyee-form .select2-container--default .select2-selection--single {
  max-width: 100% !important;
  height: 40px !important;
}

.disabled-inputs input:hover,
.disabled-inputs .select2-selection:hover {
  cursor: not-allowed !important;
}

.select2-selection__clear {
  margin-left: 15px !important;
} */
</style>
